import {
    GdAdditionalTargetingJoinType,
    GdAdditionalTargetingMode,
    GdAdditionalTargetingUatraitsInput,
    InterfaceLang
} from '../typings/graphql-grid';
import { GroupId } from '../typings/groups';

export const SAVE_INTERNAL_GROUPS = 'SAVE_INTERNAL_GROUPS';
export type SAVE_INTERNAL_GROUPS = typeof SAVE_INTERNAL_GROUPS;

export interface SaveInternalGroupsAction {
    type: SAVE_INTERNAL_GROUPS;
}

export function saveInternalGroups(): SaveInternalGroupsAction {
    return {
        type: SAVE_INTERNAL_GROUPS
    };
}

export const CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE =
    'CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE';
export type CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE = typeof CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE;

export interface AdditionalTargetingUidsValueChangeAction {
    type: CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE;
    groupId: GroupId;
    value: string;
}

export function changeAdditionalTargetingUidsValue(
    groupId: GroupId,
    value: string
): AdditionalTargetingUidsValueChangeAction {
    return {
        type: CHANGE_ADDITIONAL_TARGETING_UIDS_VALUE,
        groupId,
        value
    };
}

export const CHANGE_ADDITIONAL_TARGETING_UIDS_CONTROL =
    'CHANGE_ADDITIONAL_TARGETING_UIDS_CONTROL';
export type CHANGE_ADDITIONAL_TARGETING_NOT_UIDS_CONTROL = typeof CHANGE_ADDITIONAL_TARGETING_UIDS_CONTROL;

export interface AdditionalTargetingUidsControlChangeAction {
    type: CHANGE_ADDITIONAL_TARGETING_NOT_UIDS_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeAdditionalTargetingUidsControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): AdditionalTargetingUidsControlChangeAction {
    return {
        type: CHANGE_ADDITIONAL_TARGETING_UIDS_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CANCEL_ADDITIONAL_TARGETING_CHANGES =
    'CANCEL_ADDITIONAL_TARGETING_CHANGES';
export type CANCEL_ADDITIONAL_TARGETING_CHANGES = typeof CANCEL_ADDITIONAL_TARGETING_CHANGES;

export interface AdditionalTargetingChangesCancelAction {
    type: CANCEL_ADDITIONAL_TARGETING_CHANGES;
    groupId: GroupId;
}

export function cancelAdditionalTargetingChanges(
    groupId: GroupId
): AdditionalTargetingChangesCancelAction {
    return {
        type: CANCEL_ADDITIONAL_TARGETING_CHANGES,
        groupId
    };
}

export const SAVE_ADDITIONAL_TARGETING_CHANGES =
    'SAVE_ADDITIONAL_TARGETING_CHANGES';
export type SAVE_ADDITIONAL_TARGETING_CHANGES = typeof SAVE_ADDITIONAL_TARGETING_CHANGES;

export interface AdditionalTargetingChangesSaveAction {
    type: SAVE_ADDITIONAL_TARGETING_CHANGES;
    groupId: GroupId;
}

export function saveAdditionalTargetingChanges(
    groupId: GroupId
): AdditionalTargetingChangesSaveAction {
    return {
        type: SAVE_ADDITIONAL_TARGETING_CHANGES,
        groupId
    };
}

export const CHANGE_INTERNAL_NETWORK_CONTROL =
    'CHANGE_INTERNAL_NETWORK_CONTROL';
export type CHANGE_INTERNAL_NETWORK_CONTROL = typeof CHANGE_INTERNAL_NETWORK_CONTROL;

export interface InternalNetworkControlChangeAction {
    type: CHANGE_INTERNAL_NETWORK_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeInternalNetworkControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): InternalNetworkControlChangeAction {
    return {
        type: CHANGE_INTERNAL_NETWORK_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_IS_BROWSER_CONTROL = 'CHANGE_IS_BROWSER_CONTROL';
export type CHANGE_IS_BROWSER_CONTROL = typeof CHANGE_IS_BROWSER_CONTROL;

export interface IsBrowserControlChangeAction {
    type: CHANGE_IS_BROWSER_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeIsBrowserControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): IsBrowserControlChangeAction {
    return {
        type: CHANGE_IS_BROWSER_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_IS_TOUCH_CONTROL = 'CHANGE_IS_TOUCH_CONTROL';
export type CHANGE_IS_TOUCH_CONTROL = typeof CHANGE_IS_TOUCH_CONTROL;

export interface IsTouchControlChangeAction {
    type: CHANGE_IS_TOUCH_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeIsTouchControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): IsTouchControlChangeAction {
    return {
        type: CHANGE_IS_TOUCH_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_IS_TABLET_CONTROL = 'CHANGE_IS_TABLET_CONTROL';
export type CHANGE_IS_TABLET_CONTROL = typeof CHANGE_IS_TABLET_CONTROL;

export interface IsTabletControlChangeAction {
    type: CHANGE_IS_TABLET_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeIsTabletControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): IsTabletControlChangeAction {
    return {
        type: CHANGE_IS_TABLET_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_IS_MOBILE_CONTROL = 'CHANGE_IS_MOBILE_CONTROL';
export type CHANGE_IS_MOBILE_CONTROL = typeof CHANGE_IS_MOBILE_CONTROL;

export interface IsMobileControlChangeAction {
    type: CHANGE_IS_MOBILE_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeIsMobileControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): IsMobileControlChangeAction {
    return {
        type: CHANGE_IS_MOBILE_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_OS_NAMES_VALUE = 'CHANGE_OS_NAMES_VALUE';
export type CHANGE_OS_NAMES_VALUE = typeof CHANGE_OS_NAMES_VALUE;

export interface OsNamesValueChangeAction {
    type: CHANGE_OS_NAMES_VALUE;
    groupId: GroupId;
    value: GdAdditionalTargetingUatraitsInput[];
}

export function changeOsNamesValue(
    groupId: GroupId,
    value: GdAdditionalTargetingUatraitsInput[]
): OsNamesValueChangeAction {
    return {
        type: CHANGE_OS_NAMES_VALUE,
        groupId,
        value
    };
}

export const CHANGE_OS_NAMES_CONTROL = 'CHANGE_OS_NAMES_CONTROL';
export type CHANGE_OS_NAMES_CONTROL = typeof CHANGE_OS_NAMES_CONTROL;

export interface OsNamesControlChangeAction {
    type: CHANGE_OS_NAMES_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
}

export function changeOsNamesControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode
): OsNamesControlChangeAction {
    return {
        type: CHANGE_OS_NAMES_CONTROL,
        groupId,
        joinType,
        targetingMode
    };
}

export const CHANGE_OS_FAMILIES_VALUE = 'CHANGE_OS_FAMILIES_VALUE';
export type CHANGE_OS_FAMILIES_VALUE = typeof CHANGE_OS_FAMILIES_VALUE;

export interface OsFamiliesValueChangeAction {
    type: CHANGE_OS_FAMILIES_VALUE;
    groupId: GroupId;
    value: GdAdditionalTargetingUatraitsInput[];
}

export function changeOsFamiliesValue(
    groupId: GroupId,
    value: GdAdditionalTargetingUatraitsInput[]
): OsFamiliesValueChangeAction {
    return {
        type: CHANGE_OS_FAMILIES_VALUE,
        groupId,
        value
    };
}

export const CHANGE_OS_FAMILIES_CONTROL = 'CHANGE_OS_FAMILIES_CONTROL';
export type CHANGE_OS_FAMILIES_CONTROL = typeof CHANGE_OS_FAMILIES_CONTROL;

export interface OsFamiliesControlChangeAction {
    type: CHANGE_OS_FAMILIES_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
}

export function changeOsFamiliesControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode
): OsFamiliesControlChangeAction {
    return {
        type: CHANGE_OS_FAMILIES_CONTROL,
        groupId,
        joinType,
        targetingMode
    };
}

export const CHANGE_BROWSER_NAMES_VALUE = 'CHANGE_BROWSER_NAMES_VALUE';
export type CHANGE_BROWSER_NAMES_VALUE = typeof CHANGE_BROWSER_NAMES_VALUE;

export interface BrowserNamesValueChangeAction {
    type: CHANGE_BROWSER_NAMES_VALUE;
    groupId: GroupId;
    value: GdAdditionalTargetingUatraitsInput[];
}

export function changeBrowserNamesValue(
    groupId: GroupId,
    value: GdAdditionalTargetingUatraitsInput[]
): BrowserNamesValueChangeAction {
    return {
        type: CHANGE_BROWSER_NAMES_VALUE,
        groupId,
        value
    };
}

export const CHANGE_BROWSER_NAMES_CONTROL = 'CHANGE_BROWSER_NAMES_CONTROL';
export type CHANGE_BROWSER_NAMES_CONTROL = typeof CHANGE_BROWSER_NAMES_CONTROL;

export interface BrowserNamesControlChangeAction {
    type: CHANGE_BROWSER_NAMES_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
}

export function changeBrowserNamesControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode
): BrowserNamesControlChangeAction {
    return {
        type: CHANGE_BROWSER_NAMES_CONTROL,
        groupId,
        joinType,
        targetingMode
    };
}

export const CHANGE_BROWSER_ENGINES_VALUE = 'CHANGE_BROWSER_ENGINES_VALUE';
export type CHANGE_BROWSER_ENGINES_VALUE = typeof CHANGE_BROWSER_ENGINES_VALUE;

export interface BrowserEnginesValueChangeAction {
    type: CHANGE_BROWSER_ENGINES_VALUE;
    groupId: GroupId;
    value: GdAdditionalTargetingUatraitsInput[];
}

export function changeBrowserEnginesValue(
    groupId: GroupId,
    value: GdAdditionalTargetingUatraitsInput[]
): BrowserEnginesValueChangeAction {
    return {
        type: CHANGE_BROWSER_ENGINES_VALUE,
        groupId,
        value
    };
}

export const CHANGE_BROWSER_ENGINES_CONTROL = 'CHANGE_BROWSER_ENGINES_CONTROL';
export type CHANGE_BROWSER_ENGINES_CONTROL = typeof CHANGE_BROWSER_ENGINES_CONTROL;

export interface BrowserEnginesControlChangeAction {
    type: CHANGE_BROWSER_ENGINES_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
}

export function changeBrowserEnginesControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode
): BrowserEnginesControlChangeAction {
    return {
        type: CHANGE_BROWSER_ENGINES_CONTROL,
        groupId,
        joinType,
        targetingMode
    };
}

export const CHANGE_DEVICE_VENDORS_VALUE = 'CHANGE_DEVICE_VENDORS_VALUE';
export type CHANGE_DEVICE_VENDORS_VALUE = typeof CHANGE_DEVICE_VENDORS_VALUE;

export interface DeviceVendorsValueChangeAction {
    type: CHANGE_DEVICE_VENDORS_VALUE;
    groupId: GroupId;
    value: GdAdditionalTargetingUatraitsInput[];
}

export function changeDeviceVendorsValue(
    groupId: GroupId,
    value: GdAdditionalTargetingUatraitsInput[]
): DeviceVendorsValueChangeAction {
    return {
        type: CHANGE_DEVICE_VENDORS_VALUE,
        groupId,
        value
    };
}

export const CHANGE_DEVICE_VENDORS_CONTROL = 'CHANGE_DEVICE_VENDORS_CONTROL';
export type CHANGE_DEVICE_VENDORS_CONTROL = typeof CHANGE_DEVICE_VENDORS_CONTROL;

export interface DeviceVendorsControlChangeAction {
    type: CHANGE_DEVICE_VENDORS_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
}

export function changeDeviceVendorsControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode
): DeviceVendorsControlChangeAction {
    return {
        type: CHANGE_DEVICE_VENDORS_CONTROL,
        groupId,
        joinType,
        targetingMode
    };
}

export const CHANGE_DEVICE_NAMES_VALUE = 'CHANGE_DEVICE_NAMES_VALUE';
export type CHANGE_DEVICE_NAMES_VALUE = typeof CHANGE_DEVICE_NAMES_VALUE;

export interface DeviceNamesValueChangeAction {
    type: CHANGE_DEVICE_NAMES_VALUE;
    groupId: GroupId;
    value: string;
}

export function changeDeviceNamesValue(
    groupId: GroupId,
    value: string
): DeviceNamesValueChangeAction {
    return {
        type: CHANGE_DEVICE_NAMES_VALUE,
        groupId,
        value
    };
}

export const CHANGE_DEVICE_NAMES_CONTROL = 'CHANGE_DEVICE_NAMES_CONTROL';
export type CHANGE_DEVICE_NAMES_CONTROL = typeof CHANGE_DEVICE_NAMES_CONTROL;

export interface DeviceNamesControlChangeAction {
    type: CHANGE_DEVICE_NAMES_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeDeviceNamesControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): DeviceNamesControlChangeAction {
    return {
        type: CHANGE_DEVICE_NAMES_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_USER_AGENTS_VALUE = 'CHANGE_USER_AGENTS_VALUE';
export type CHANGE_USER_AGENTS_VALUE = typeof CHANGE_USER_AGENTS_VALUE;

export interface UserAgentsValueChangeAction {
    type: CHANGE_USER_AGENTS_VALUE;
    groupId: GroupId;
    value: string;
}

export function changeUserAgentsValue(
    groupId: GroupId,
    value: string
): UserAgentsValueChangeAction {
    return {
        type: CHANGE_USER_AGENTS_VALUE,
        groupId,
        value
    };
}

export const CHANGE_USER_AGENTS_CONTROL = 'CHANGE_USER_AGENTS_CONTROL';
export type CHANGE_USER_AGENTS_CONTROL = typeof CHANGE_USER_AGENTS_CONTROL;

export interface UserAgentsControlChangeAction {
    type: CHANGE_USER_AGENTS_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeUserAgentsControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): UserAgentsControlChangeAction {
    return {
        type: CHANGE_USER_AGENTS_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_QUERY_REFERERS_VALUE = 'CHANGE_QUERY_REFERERS_VALUE';
export type CHANGE_QUERY_REFERERS_VALUE = typeof CHANGE_QUERY_REFERERS_VALUE;

export interface QueryReferersValueChangeAction {
    type: CHANGE_QUERY_REFERERS_VALUE;
    groupId: GroupId;
    value: string;
}

export function changeQueryReferersValue(
    groupId: GroupId,
    value: string
): QueryReferersValueChangeAction {
    return {
        type: CHANGE_QUERY_REFERERS_VALUE,
        groupId,
        value
    };
}

export const CHANGE_QUERY_REFERERS_CONTROL = 'CHANGE_QUERY_REFERERS_CONTROL';
export type CHANGE_QUERY_REFERERS_CONTROL = typeof CHANGE_QUERY_REFERERS_CONTROL;

export interface QueryReferersControlChangeAction {
    type: CHANGE_QUERY_REFERERS_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeQueryReferersControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): QueryReferersControlChangeAction {
    return {
        type: CHANGE_QUERY_REFERERS_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_INTERFACE_LANGS_VALUE = 'CHANGE_INTERFACE_LANGS_VALUE';
export type CHANGE_INTERFACE_LANGS_VALUE = typeof CHANGE_INTERFACE_LANGS_VALUE;

export interface InterfaceLangsValueChangeAction {
    type: CHANGE_INTERFACE_LANGS_VALUE;
    groupId: GroupId;
    value: InterfaceLang[];
}

export function changeInterfaceLangsValue(
    groupId: GroupId,
    value: InterfaceLang[]
): InterfaceLangsValueChangeAction {
    return {
        type: CHANGE_INTERFACE_LANGS_VALUE,
        groupId,
        value
    };
}

export const CHANGE_INTERFACE_LANGS_CONTROL = 'CHANGE_INTERFACE_LANGS_CONTROL';
export type CHANGE_INTERFACE_LANGS_CONTROL = typeof CHANGE_INTERFACE_LANGS_CONTROL;

export interface InterfaceLangsControlChangeAction {
    type: CHANGE_INTERFACE_LANGS_CONTROL;
    groupId: GroupId;
    joinType: GdAdditionalTargetingJoinType;
    targetingMode: GdAdditionalTargetingMode;
    uncheckAll: boolean;
}

export function changeInterfaceLangsControl(
    groupId: GroupId,
    joinType: GdAdditionalTargetingJoinType,
    targetingMode: GdAdditionalTargetingMode,
    uncheckAll: boolean = false
): InterfaceLangsControlChangeAction {
    return {
        type: CHANGE_INTERFACE_LANGS_CONTROL,
        groupId,
        joinType,
        targetingMode,
        uncheckAll
    };
}

export const CHANGE_PRIORITY_VALUE = 'CHANGE_PRIORITY_VALUE';
export type CHANGE_PRIORITY_VALUE = typeof CHANGE_PRIORITY_VALUE;

export interface PriorityValueChangeAction {
    type: CHANGE_PRIORITY_VALUE;
    groupId: GroupId;
    value: string;
}

export function changePriorityValue(
    groupId: GroupId,
    value: string
): PriorityValueChangeAction {
    return {
        type: CHANGE_PRIORITY_VALUE,
        groupId,
        value
    };
}

export const OPEN_ADDITIONAL_TARGETING_INTERNAL =
    'OPEN_ADDITIONAL_TARGETING_INTERNAL';
export type OPEN_ADDITIONAL_TARGETING_INTERNAL = typeof OPEN_ADDITIONAL_TARGETING_INTERNAL;

export interface AdditionalTargetingInternalOpenAction {
    type: OPEN_ADDITIONAL_TARGETING_INTERNAL;
    groupId: GroupId;
}

export function openAdditionalTargetingInternal(
    groupId: GroupId
): AdditionalTargetingInternalOpenAction {
    return {
        type: OPEN_ADDITIONAL_TARGETING_INTERNAL,
        groupId
    };
}

export const CLOSE_ADDITIONAL_TARGETING_INTERNAL =
    'CLOSE_ADDITIONAL_TARGETING_INTERNAL';
export type CLOSE_ADDITIONAL_TARGETING_INTERNAL = typeof CLOSE_ADDITIONAL_TARGETING_INTERNAL;

export interface AdditionalTargetingInternalCloseAction {
    type: CLOSE_ADDITIONAL_TARGETING_INTERNAL;
    groupId: GroupId;
}

export function closeAdditionalTargetingInternal(
    groupId: GroupId
): AdditionalTargetingInternalCloseAction {
    return {
        type: CLOSE_ADDITIONAL_TARGETING_INTERNAL,
        groupId
    };
}

export type GroupsEditInternalActions =
    | AdditionalTargetingUidsValueChangeAction
    | AdditionalTargetingUidsControlChangeAction
    | AdditionalTargetingChangesCancelAction
    | AdditionalTargetingChangesSaveAction
    | InternalNetworkControlChangeAction
    | IsBrowserControlChangeAction
    | IsTabletControlChangeAction
    | IsMobileControlChangeAction
    | IsTouchControlChangeAction
    | OsNamesValueChangeAction
    | OsNamesControlChangeAction
    | OsFamiliesValueChangeAction
    | OsFamiliesControlChangeAction
    | BrowserNamesControlChangeAction
    | BrowserNamesValueChangeAction
    | BrowserEnginesControlChangeAction
    | BrowserEnginesValueChangeAction
    | DeviceVendorsControlChangeAction
    | DeviceVendorsValueChangeAction
    | DeviceNamesValueChangeAction
    | DeviceNamesControlChangeAction
    | UserAgentsValueChangeAction
    | UserAgentsControlChangeAction
    | QueryReferersValueChangeAction
    | QueryReferersControlChangeAction
    | InterfaceLangsValueChangeAction
    | InterfaceLangsControlChangeAction
    | PriorityValueChangeAction
    | AdditionalTargetingInternalCloseAction
    | SaveInternalGroupsAction
    | AdditionalTargetingInternalOpenAction;
